import script from "./PostListView.vue?vue&type=script&setup=true&lang=js"
export * from "./PostListView.vue?vue&type=script&setup=true&lang=js"

import "./PostListView.vue?vue&type=style&index=0&id=3900fee3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3900fee3"]])

export default __exports__